export default __webpack_public_path__ + "static/media/ml2.68e8e1bc.png";